/* eslint max-classes-per-file: 0 */

import {
  KimUser as Data,
  KimUserCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class KimUsersApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'kims_users';

  protected readonly hasFinishSlash = false;
}
